import t from"./_getNative.js";import o from"./_root.js";var r=t(o,"DataView");export{r as default};
//# sourceMappingURL=_DataView.js.map
